import React, { useEffect, useState } from "react";
import api from "../utils/base_url";
import '../styles/index.css';

const Footer = ({ categories = [] }) => {
  const [footerCategories, setFooterCategories] = useState([]);

  useEffect(() => {
    let didCancel = false;
    const fetchCategories = async () => {
      try {
        const res = await api.get("categorylist/");
        if (!didCancel && res.data?.status && Array.isArray(res.data.data)) {
          setFooterCategories(res.data.data);
        }
      } catch (err) {
        if (!didCancel) console.error("Error fetching footer categories:", err);
      }
    };
    if (categories.length > 0) {
      setFooterCategories(categories);
    } else if (footerCategories.length === 0) {
      fetchCategories();
    }
    return () => { didCancel = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ── Social links — update hrefs as needed ── */
  const socials = [
    {
      href: "https://www.instagram.com/vannakkarangal/",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24"
          fill="none" stroke="url(#ig1)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <defs>
            <linearGradient id="ig1" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%"  stopColor="#fdf497" />
              <stop offset="45%" stopColor="#fd5949" />
              <stop offset="60%" stopColor="#d6249f" />
              <stop offset="90%" stopColor="#285AEB" />
            </linearGradient>
          </defs>
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
          <line x1="17.5" y1="6.5" x2="17.5" y2="6.5" />
        </svg>
      ),
      bg: "linear-gradient(135deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)",
    },
    {
      href: "https://www.instagram.com/vannakkarangal_farmfresh?igsh=MWZzazRpeGRwdmIzOA%3D%3D", // ← replace with 2nd account URL
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24"
          fill="none" stroke="url(#ig2)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <defs>
            <linearGradient id="ig2" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%"  stopColor="#fdf497" />
              <stop offset="45%" stopColor="#fd5949" />
              <stop offset="60%" stopColor="#d6249f" />
              <stop offset="90%" stopColor="#285AEB" />
            </linearGradient>
          </defs>
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
          <line x1="17.5" y1="6.5" x2="17.5" y2="6.5" />
        </svg>
      ),
      bg: "linear-gradient(135deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)",
    },
    {
      href: "https://www.facebook.com/profile.php?id=61584659768856&rdid=sJWSERE8oURTyUGl&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1H9XxZdFsS%2F#",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24"
          fill="#1877F2">
          <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.235 2.686.235v2.97h-1.513c-1.491 0-1.956.93-1.956 1.884v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
        </svg>
      ),
      bg: "#1877F2",
    },
    {
      href: "https://www.youtube.com/@vannakkarangal",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24"
          fill="#FF0000">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      ),
      bg: "#FF0000",
    },
  ];

  return (
    <footer className="footer-wrapper">

      {/* ── MAP ── */}
      <div className="map-wrapper">
        <iframe
          title="Shop Location"
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3915.0733012308424!2d77.59757617504668!3d11.107914889061673!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTHCsDA2JzI4LjUiTiA3N8KwMzYnMDAuNSJF!5e0!3m2!1sen!2sin!4v1768120944149!5m2!1sen!2sin"
          width="100%" height="300"
          style={{ border: 0 }}
          allowFullScreen="" loading="lazy"
        />
        <div className="map-overlay"><span>Find Us Here</span></div>
      </div>

      {/* ── CONTACT / LINKS / SOCIAL ── */}
      <div className="footer-info container py-4">
        <div className="row">

          {/* Address */}
          <div className="col-md-4 mb-4 text-center text-md-start">
            <h5 className="fw-bold mb-2" style={{ color: "#8A4B27" }}>Vannakkarangal</h5>
            <p className="small mb-1">17/53, periyakadu, siviyarpalayam,</p>
            <p className="small mb-1">N. K. Valasu (po), kangeyam – 638701</p>
            <p className="small mb-1">📞 +91 88703 41300</p>
            <p className="small">📧 vannakkarangal@gmail.com</p>
          </div>

          {/* Quick Links */}
          <div className="col-md-4 mb-4 text-center">
            <h6 className="fw-bold mb-2" style={{ color: "#8A4B27" }}>Quick Links</h6>
            <ul className="list-unstyled small">
              <li><a href="/policies#terms">Terms &amp; Conditions</a></li>
              <li><a href="/policies#privacy">Privacy Policy</a></li>
              <li><a href="/policies#refund">Return &amp; Refund Policy</a></li>
              <li><a href="/policies#shipping">Shipping &amp; Payment Policy</a></li>
            </ul>
          </div>

          {/* Follow Us */}
          <div className="col-md-4 text-center">
            <h6 className="fw-bold mb-3" style={{ color: "#8A4B27" }}>Follow Us</h6>

            <div className="social-grid">
              {socials.map((s, i) => (
                <a key={i} href={s.href} target="_blank" rel="noopener noreferrer"
                  className="social-btn" title={s.label}
                  style={{ "--social-bg": s.bg }}>
                  {s.icon}
                  <span className="social-label">{s.label}</span>
                </a>
              ))}
            </div>
          </div>

        </div>
      </div>

      {/* ── BOTTOM ── */}
      <div className="footer-bottom text-center py-3">
        <small>
          © {new Date().getFullYear()} Vannakkarangal. Powered by{" "}
          <a href="https://scaleupstores.com/" target="_blank" rel="noopener noreferrer">
            Scaleup Stores
          </a>
        </small>
      </div>

      <style>{`
        /* ── wrapper ── */
        .footer-wrapper {
          background: #E9DCC3;
          border-top: 2px solid #8A4B27;
          color: #333;
        }

        /* ── links ── */
        .footer-info a {
          color: #000;
          text-decoration: none;
        }
        .footer-info a:hover { text-decoration: underline; }

        /* ── bottom bar ── */
        .footer-bottom {
          background-color: #E9DCC3;
          color: #444;
          border-top: 1px solid #8A4B27;
        }
        .footer-bottom a { color: #8A4B27; }

        /* ── map ── */
        .map-wrapper {
          position: relative; width: 100%; height: 300px; overflow: hidden;
        }
        .map-wrapper iframe { width: 100%; height: 100%; }
        .map-overlay {
          position: absolute; inset: 0;
          background: rgba(0,0,0,0.5);
          color: white;
          display: flex; align-items: center; justify-content: center;
          font-size: 1.4rem; font-weight: 500; letter-spacing: 1px;
          transition: opacity 0.3s ease; pointer-events: none;
        }
        .map-wrapper:hover .map-overlay { opacity: 0; }
            /* ── social icons only ── */
            .social-grid {
              display: grid;
              grid-template-columns: repeat(2, auto);
              gap: 18px;
              justify-content: center;
              align-items: center;
            }

            /* remove white bg */
            .social-btn {
              display: flex;
              align-items: center;
              justify-content: center;
              background: transparent !important;
              box-shadow: none !important;
              border-radius: 0;
              padding: 0;
              width: auto;
              height: auto;
              transition: transform 0.25s ease;
            }

            /* simple hover */
            .social-btn:hover {
              background: transparent !important;
              transform: scale(1.12);
              box-shadow: none !important;
            }

            /* keep original colors */
            .social-btn:hover svg {
              filter: none !important;
            }

            /* hide text */
            .social-label {
              display: none;
            }

            /* mobile */
            @media (max-width: 768px) {
              .social-grid {
                gap: 16px;
              }
            }
            /* ── tablet/mobile ── */
            @media (max-width: 768px) {

              .footer-info .row {
                text-align: center;
              }

              .social-grid {
                display: grid;
                grid-template-columns: repeat(2, auto);
                justify-content: center;
                align-items: center;
                gap: 20px;
                max-width: 180px;
                margin: 0 auto;
              }

              .social-btn {
                padding: 0;
                width: auto;
                height: auto;
              }

              .social-btn svg {
                width: 36px;
                height: 36px;
              }

              .social-label {
                display: none;
              }
            }

            /* ── small mobile ── */
            @media (max-width: 480px) {

              .social-grid {
                gap: 18px;
                max-width: 160px;
              }

              .social-btn svg {
                width: 32px;
                height: 32px;
              }
            }

            /* ── very small devices ── */
            @media (max-width: 360px) {

              .social-grid {
                gap: 14px;
                max-width: 140px;
              }

              .social-btn svg {
                width: 28px;
                height: 28px;
              }
            }
      `}</style>
    </footer>
  );
};

export default Footer;